// Constantes del módulo Peticiones

// Tipos de petición (deben coincidir con backend)
export const PETICION_TIPO = {
    PETICION: {
        value: 'PETICION',
        label: 'Petición',
        descripcion: 'Petición estándar asociada a un albarán de cliente'
    },
    REPOSICION: {
        value: 'REPOSICION',
        label: 'Reposición',
        descripcion: 'Reposición preventiva de stock sin albarán'
    }
};

// Helper para obtener todos los tipos como array
export const PETICION_TIPOS_ARRAY = Object.values(PETICION_TIPO);

// Helper para obtener tipo por value
export const getPeticionTipo = (value) => {
    return Object.values(PETICION_TIPO).find(tipo => tipo.value === value);
};

export const PETICION_ESTADO = {
    NO_ATENDIDO: {
        value: 'NO_ATENDIDO',
        label: 'No atendido',
        chip: 'secondary'
    },
    EN_PROCESO: {
        value: 'EN_PROCESO',
        label: 'En proceso',
        chip: 'warning'
    },
    PREPARADO: {
        value: 'PREPARADO',
        label: 'Preparado',
        chip: 'success'
    }
};

// Helper para obtener todas las opciones como array
export const PETICION_ESTADOS_ARRAY = Object.values(PETICION_ESTADO);

// Helper para obtener estado por value
export const getPeticionEstado = (value) => {
    return Object.values(PETICION_ESTADO).find(estado => estado.value === value);
};
